/* Tyler Evyns theme — header, theme toggle, gallery, variant + quantity UI */
(function () {
  'use strict';

  var root = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Color mode ---------- */
  var theme = root.getAttribute('data-theme') || 'dark';
  var toggle = document.querySelector('.theme-toggle');
  if (toggle) {
    toggle.addEventListener('click', function () {
      theme = theme === 'dark' ? 'light' : 'dark';
      root.setAttribute('data-theme', theme);
      toggle.setAttribute('aria-label', theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode');
      toggle.setAttribute('aria-pressed', String(theme === 'light'));
    });
  }

  /* ---------- Mobile nav ---------- */
  var menuBtn = document.querySelector('.menu-btn');
  var mobileNav = document.getElementById('mobile-nav');
  if (menuBtn && mobileNav) {
    menuBtn.addEventListener('click', function () {
      var open = mobileNav.getAttribute('data-open') === 'true';
      mobileNav.setAttribute('data-open', String(!open));
      menuBtn.setAttribute('aria-expanded', String(!open));
    });
  }

  /* ---------- Product gallery ---------- */
  var mainImg = document.getElementById('product-image');
  var thumbs = document.querySelectorAll('.thumb');

  function setGalleryViews(front, back, label) {
    var frontThumb = document.querySelector('.thumb[data-view="front"]');
    var backThumb = document.querySelector('.thumb[data-view="back"]');
    if (!frontThumb || !backThumb || !front || !back) return;

    frontThumb.dataset.full = front;
    frontThumb.dataset.alt = label + ' Tyler Evyns tee, front view';
    frontThumb.setAttribute('aria-label', 'Show ' + label + ' front view');
    frontThumb.querySelector('img').src = front;

    backThumb.dataset.full = back;
    backThumb.dataset.alt = label + ' Tyler Evyns tee, back view';
    backThumb.setAttribute('aria-label', 'Show ' + label + ' back view');
    backThumb.querySelector('img').src = back;

    Array.prototype.forEach.call(thumbs, function (thumb) {
      thumb.setAttribute('aria-pressed', thumb === frontThumb ? 'true' : 'false');
    });
    if (mainImg) {
      mainImg.srcset = '';
      mainImg.src = front;
      mainImg.alt = label + ' Tyler Evyns tee, front view';
    }
  }

  Array.prototype.forEach.call(thumbs, function (t) {
    t.addEventListener('click', function () {
      Array.prototype.forEach.call(thumbs, function (o) {
        o.setAttribute('aria-pressed', 'false');
      });
      t.setAttribute('aria-pressed', 'true');
      if (mainImg) {
        mainImg.srcset = '';
        mainImg.src = t.dataset.full;
        mainImg.alt = t.dataset.alt || '';
      }
    });
  });
  Array.prototype.forEach.call(document.querySelectorAll('[data-gallery-direction]'), function (button) {
    if (thumbs.length < 2) {
      button.hidden = true;
      return;
    }
    button.addEventListener('click', function () {
      var activeIndex = 0;
      Array.prototype.forEach.call(thumbs, function (thumb, index) {
        if (thumb.getAttribute('aria-pressed') === 'true') activeIndex = index;
      });
      var direction = parseInt(button.dataset.galleryDirection, 10);
      var nextIndex = (activeIndex + direction + thumbs.length) % thumbs.length;
      thumbs[nextIndex].click();
    });
  });

  /* ---------- Preview product color selector ---------- */
  var colors = document.querySelectorAll('.color-choice');
  var colorOut = document.getElementById('color-selected');
  Array.prototype.forEach.call(colors, function (b) {
    b.addEventListener('click', function () {
      Array.prototype.forEach.call(colors, function (o) {
        o.setAttribute('aria-pressed', 'false');
      });
      b.setAttribute('aria-pressed', 'true');
      if (colorOut) colorOut.textContent = b.dataset.label;

      setGalleryViews(b.dataset.front, b.dataset.back, b.dataset.label);
    });
  });

  /* ---------- Option buttons -> hidden variant <select> ---------- */
  var variantSelect = document.getElementById('variant-select');
  var sizeButtons = document.querySelectorAll('.size');
  var sizeOut = document.getElementById('size-selected');

  function selectedOptions() {
    var chosen = [];
    Array.prototype.forEach.call(sizeButtons, function (b) {
      if (b.getAttribute('aria-pressed') === 'true') {
        chosen[parseInt(b.dataset.optionIndex || 0, 10)] = b.dataset.size;
      }
    });
    return chosen;
  }

  function syncVariant() {
    if (!variantSelect) return;
    var chosen = selectedOptions().join(' / ');
    Array.prototype.forEach.call(variantSelect.options, function (opt) {
      if (opt.textContent.trim() === chosen) {
        variantSelect.value = opt.value;
      }
    });
  }

  Array.prototype.forEach.call(sizeButtons, function (b) {
    b.addEventListener('click', function () {
      if (b.disabled) return;
      var group = b.parentNode.querySelectorAll('.size');
      Array.prototype.forEach.call(group, function (o) {
        o.setAttribute('aria-pressed', 'false');
      });
      b.setAttribute('aria-pressed', 'true');
      var label = b.closest('.field') && b.closest('.field').querySelector('#size-selected');
      if (label) label.textContent = b.dataset.size;
      else if (sizeOut) sizeOut.textContent = b.dataset.size;
      syncVariant();
      if (b.dataset.front && b.dataset.back) {
        setGalleryViews(b.dataset.front, b.dataset.back, b.dataset.colorLabel || b.dataset.size);
      }
    });
  });

  /* ---------- Quantity ---------- */
  var qtyEl = document.getElementById('qty-value');
  var qty = 1;
  function setQty(next) {
    qty = Math.min(10, Math.max(1, next));
    if (qtyEl) {
      if ('value' in qtyEl) qtyEl.value = String(qty);
      else qtyEl.textContent = String(qty);
    }
  }
  Array.prototype.forEach.call(document.querySelectorAll('[data-qty]'), function (b) {
    b.addEventListener('click', function () {
      setQty(qty + parseInt(b.dataset.qty, 10));
    });
  });
  setQty(1);

  /* ---------- Floating cart ---------- */
  var floatingCart = document.querySelector('[data-floating-cart]');
  var cartCount = floatingCart && floatingCart.querySelector('[data-cart-count]');
  var headerCart = document.querySelector('[data-header-cart]');
  var cartDrawer = document.getElementById('cart-drawer');
  var cartDrawerItems = cartDrawer && cartDrawer.querySelector('[data-cart-drawer-items]');
  var cartDrawerFooter = cartDrawer && cartDrawer.querySelector('[data-cart-drawer-footer]');
  var cartDrawerTotal = cartDrawer && cartDrawer.querySelector('[data-cart-drawer-total]');
  var rootPath = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';

  function money(cents) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
      style: 'currency',
      currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'USD'
    }).format(cents / 100);
  }

  function updateCartCounts(count) {
    var itemWord = count === 1 ? 'item' : 'items';
    if (headerCart) headerCart.setAttribute('aria-label', 'Cart (' + count + ' ' + itemWord + ')');
    if (!floatingCart || !cartCount) return;
    cartCount.textContent = String(count);
    floatingCart.setAttribute('aria-label', 'View cart, ' + count + ' ' + itemWord);
    floatingCart.setAttribute('aria-hidden', count > 0 ? 'false' : 'true');
    if (count > 0) {
      floatingCart.removeAttribute('tabindex');
      floatingCart.classList.add('is-visible');
    } else {
      floatingCart.setAttribute('tabindex', '-1');
      floatingCart.classList.remove('is-visible');
    }
  }

  function showFloatingCart(count) {
    updateCartCounts(count);
  }

  function renderCartDrawer(cart) {
    updateCartCounts(cart.item_count);
    if (!cartDrawerItems || !cartDrawerFooter) return;
    cartDrawerItems.innerHTML = '';
    if (!cart.items.length) {
      var empty = document.createElement('p');
      empty.className = 'cart-drawer__empty';
      empty.textContent = 'Your cart is empty.';
      cartDrawerItems.appendChild(empty);
      cartDrawerFooter.hidden = true;
      return;
    }
    cart.items.forEach(function (item, index) {
      var row = document.createElement('article');
      row.className = 'cart-drawer__item';

      var image = document.createElement('img');
      image.src = item.featured_image && item.featured_image.url ? item.featured_image.url : item.image;
      image.alt = item.product_title;
      image.width = 112;
      image.height = 112;

      var info = document.createElement('div');
      info.className = 'cart-drawer__item-info';
      var title = document.createElement('strong');
      title.textContent = item.product_title;
      var options = document.createElement('p');
      options.textContent = item.options_with_values.map(function (option) {
        return option.name + ': ' + option.value;
      }).join(' · ');
      var quantity = document.createElement('p');
      quantity.textContent = 'Quantity: ' + item.quantity;
      var price = document.createElement('span');
      price.className = 'cart-drawer__item-price';
      price.textContent = money(item.final_line_price);
      var remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'cart-drawer__remove';
      remove.textContent = 'Remove';
      remove.setAttribute('aria-label', 'Remove ' + item.product_title + ' from cart');
      remove.addEventListener('click', function () {
        remove.disabled = true;
        fetch(rootPath + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: index + 1, quantity: 0 })
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Unable to remove item.');
            return response.json();
          })
          .then(renderCartDrawer)
          .catch(function () { remove.disabled = false; });
      });
      info.appendChild(title);
      info.appendChild(options);
      info.appendChild(quantity);
      info.appendChild(price);
      info.appendChild(remove);
      row.appendChild(image);
      row.appendChild(info);
      cartDrawerItems.appendChild(row);
    });
    if (cartDrawerTotal) cartDrawerTotal.textContent = money(cart.total_price);
    cartDrawerFooter.hidden = false;
  }

  function openCartDrawer() {
    if (!cartDrawer || typeof cartDrawer.showModal !== 'function') {
      window.location.href = rootPath + 'cart';
      return;
    }
    cartDrawerItems.innerHTML = '<p class="cart-drawer__empty">Loading your cart…</p>';
    cartDrawerFooter.hidden = true;
    cartDrawer.showModal();
    fetch(rootPath + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to load cart.');
        return response.json();
      })
      .then(renderCartDrawer)
      .catch(function () {
        cartDrawerItems.innerHTML = '<p class="cart-drawer__empty">Unable to load your cart. Please use the full cart page.</p>';
      });
  }

  if (floatingCart) floatingCart.addEventListener('click', openCartDrawer);
  if (headerCart) {
    headerCart.addEventListener('click', function (event) {
      if (!cartDrawer || typeof cartDrawer.showModal !== 'function') return;
      event.preventDefault();
      openCartDrawer();
    });
  }
  var cartDrawerClose = cartDrawer && cartDrawer.querySelector('[data-cart-drawer-close]');
  if (cartDrawerClose) cartDrawerClose.addEventListener('click', function () { cartDrawer.close(); });
  if (cartDrawer) {
    cartDrawer.addEventListener('click', function (event) {
      if (event.target === cartDrawer) cartDrawer.close();
    });
  }

  /* ---------- Add selected Shopify variant, then show the cart ---------- */
  var productForm = document.getElementById('product-form');
  if (productForm) {
    productForm.addEventListener('submit', function (event) {
      event.preventDefault();
      syncVariant();
      var addBtn = productForm.querySelector('[name="add"]');
      var label = addBtn && addBtn.querySelector('span');
      var original = label ? label.textContent : 'Add to cart';
      if (addBtn) addBtn.disabled = true;
      if (label) label.textContent = 'Adding…';
      fetch(rootPath + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(productForm)
        })
        .then(function (response) {
          if (!response.ok) return response.json().then(function (data) { throw new Error(data.description || 'Unable to add this item.'); });
          return response.json();
        })
        .then(function () {
          return fetch(rootPath + 'cart.js', {
            headers: { Accept: 'application/json' }
          });
        })
        .then(function (response) {
          if (!response.ok) throw new Error('Item added. Open the cart to continue.');
          return response.json();
        })
        .then(function (cart) {
          showFloatingCart(cart.item_count);
          renderCartDrawer(cart);
          openCartDrawer();
          if (label) label.textContent = 'Added to cart';
          if (addBtn) addBtn.disabled = false;
          setTimeout(function () {
            if (label) label.textContent = original;
          }, 1800);
        })
        .catch(function (error) {
          if (label) label.textContent = error.message || 'Try again';
          if (addBtn) addBtn.disabled = false;
          setTimeout(function () {
            if (label) label.textContent = original;
          }, 3000);
        });
    });
  }

  /* ---------- Policy dialogs ---------- */
  Array.prototype.forEach.call(document.querySelectorAll('[data-policy-open]'), function (button) {
    button.addEventListener('click', function () {
      var dialog = document.getElementById(button.dataset.policyOpen);
      if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
    });
  });
  Array.prototype.forEach.call(document.querySelectorAll('.policy-dialog'), function (dialog) {
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) dialog.close();
    });
  });

  /* ---------- Opening text-list popup ---------- */
  var textPopup = document.getElementById('text-list-popup');
  var textPopupCloseButtons = document.querySelectorAll('[data-text-popup-close]');
  var textPopupForm = document.getElementById('text-popup-form');
  var textPopupSuccess = textPopup && textPopup.querySelector('[data-text-popup-success]');
  var textPopupCookie = 'tyler_text_popup_dismissed=1';
  var textPopupDismissed = document.cookie.split(';').some(function (cookie) {
    return cookie.trim() === textPopupCookie;
  });
  function rememberTextPopupDismissal() {
    document.cookie = textPopupCookie + '; Path=/; Max-Age=315360000; SameSite=Lax';
  }
  if (textPopup && typeof textPopup.showModal === 'function' && (textPopupSuccess || !textPopupDismissed)) {
    textPopup.showModal();
    Array.prototype.forEach.call(textPopupCloseButtons, function (button) {
      button.addEventListener('click', function () {
        rememberTextPopupDismissal();
        textPopup.close();
      });
    });
    textPopup.addEventListener('click', function (event) {
      if (event.target === textPopup) textPopup.close();
    });
  }
  if (textPopupForm) {
    textPopupForm.addEventListener('submit', rememberTextPopupDismissal);
  }

  /* ---------- Back to top ---------- */
  var backToTop = document.querySelector('.back-to-top');
  if (backToTop) {
    function updateBackToTop() {
      backToTop.classList.toggle('is-visible', window.scrollY > window.innerHeight * 0.9);
    }
    window.addEventListener('scroll', updateBackToTop, { passive: true });
    backToTop.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    });
    updateBackToTop();
  }

  /* ---------- Scroll reveal ---------- */
  var revealables = document.querySelectorAll('.reveal');
  if (reduce || !('IntersectionObserver' in window)) {
    Array.prototype.forEach.call(revealables, function (el) {
      el.classList.add('is-in');
    });
  } else {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '200px 0px 0px 0px', threshold: 0 }
    );
    Array.prototype.forEach.call(revealables, function (el) {
      io.observe(el);
    });
    // Safety net: never leave a section invisible if the observer is outrun
    window.addEventListener('load', function () {
      setTimeout(function () {
        Array.prototype.forEach.call(revealables, function (el) {
          var r = el.getBoundingClientRect();
          if (r.top < window.innerHeight + 200) el.classList.add('is-in');
        });
      }, 400);
    });
  }
})();
